import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=0f24fe72&scoped=true"
import script from "@/views/Settings/Attributes/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Attributes/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Attributes/create-dialog.scss?vue&type=style&index=0&id=0f24fe72&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24fe72",
  null
  
)

export default component.exports